// extracted by mini-css-extract-plugin
module.exports = {"root":"PageOneHeader_root__34A5M"};